/***************************************************************
5/27/2017
Alexander Self
Timesheet modal table
- Work Table Summary of timesheet to be submitted for review;
***************************************************************/
import React from 'react';
import { totalHours } from '../../../utils';

const TimesheetWorkTable = ({ workPerformed }) => {
  return (
    <table className="highlight bordered responsive-table centered">
      <thead>
        <tr>
          <th>Work</th>
          <th>Hours</th>
          <th>Temp Grade</th>
          <th>Field</th>
          <th>Block</th>
          <th>Pay Code</th>
          <th>Cost Center</th>
          <th>Subaccount</th>
          <th>Equip No.</th>
          <th>Equip Trailer</th>
          <th>Detail</th>
          <th>Differential</th>
          <th>Trainer</th>
        </tr>
      </thead>
      <tbody>
        {
          workPerformed.map((w) => {
            if (w.field === 'Select') w.field = '';
            return (
              <tr key={Math.random()}>
                <td>{ w.workPerformed }</td>
                <td>{ w.hours }</td>
                <td>{ w.tempGrade }</td>
                <td>{ w.field }</td>
                <td>{ w.block }</td>
                <td>{ w.paycode }</td>
                <td>{ w.costCenterCode }</td>
                <td>{ w.subAccount }</td>
                <td>{ w.equipmentNo }</td>
                <td>{ w.equipmentTrailerNo }</td>
                <td>{ w.detail }</td>
                <td>{ w.differential }</td>
                <td>{ Number(w.trainer) === 1 ? <i className="material-icons">done</i> : '' }</td>
              </tr>
            )
          })
        }
      </tbody>
      <tfoot>
        <tr>
          <td>Total Hours</td>
          <td><center><b>{ totalHours(workPerformed) }</b></center></td>
        </tr>
      </tfoot>
    </table>
  );
};

export default TimesheetWorkTable;



// WEBPACK FOOTER //
// ./src/components/timesheets/create/timesheet_modal_work_table.js